import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const Income = (store) => ({
  path: ROUTE.INCOME,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'income',
    loadReducer: () => import('./IncomeState'),
    loadComponent: () => import('./IncomeContainer'),
  })
})

export default Income
